import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Renderer2,
} from '@angular/core';
import { NavigationConfig } from '../../../config/app-config';
import {
  trigger,
  style,
  animate,
  transition,
  keyframes,
} from '@angular/animations';
import { NavigationMenuService } from '../../../core/services/navigation-menu.service';
import { SessionService } from '../../../core/services/session.service';
// import { Socket } from '@app/main/socket-io/socket-io.service';
import { DrawerMode } from '@app/core/types/drawer-mode';
import { Socket } from '@app/main/socket-io/socket-io.service';
import { PbxEvents } from '@app/main/socket-io/types/pbx-event.enum';
import { Call } from '@app/core/types/call';
import { CalculatorDialogService } from '@app/core/services/calcualtor-dialog.service';
import { Currency, FxService } from '@app/core/services/fx.service';
import { TranslateService } from '@ngx-translate/core';
import { PbxSocket } from '@app/main/socket-io/pbx-socket.service';

@Component({
  selector: 'itfg-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  animations: [
    trigger('toolbarCollapse', [
      transition(':enter', [style({ opacity: 0 }), animate(200)]),
    ]),
    trigger('jiggle', [
      transition('false => true', [
        animate(
          '3s ease-in-out',
          keyframes([
            style({ transform: 'rotate(-10deg)' }),
            style({ transform: 'rotate(10deg)' }),
            style({ transform: 'rotate(-10deg)' }),
            style({ transform: 'rotate(10deg)' }),
            style({ transform: 'none' }),
          ])
        ),
      ]),
    ]),
  ],
  standalone: false,
})
export class ToolbarComponent implements OnInit {
  @Input() config: NavigationConfig;
  @Input() mode: string;
  @Input() collapsed;
  @Input() toggleLeftSideNav: Function;

  @Output() searchEvent = new EventEmitter<boolean>();

  DrawerModeType = DrawerMode;
  callNotificationAnimation: boolean = false;
  hasCallNotifications: boolean = false;
  currentLanguage: string = 'bg';

  get isBGN(): boolean {
    return this.fxService.displayCurrency() === Currency.BGN;
  }

  constructor(
    private navigationMenuService: NavigationMenuService,
    public sessionService: SessionService,
    public socketService: PbxSocket,
    private renderer: Renderer2,
    private calculatorService: CalculatorDialogService,
    private fxService: FxService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.currentLanguage = localStorage.getItem('translationLanguage') || 'bg';

    this.socketService.on(PbxEvents.NOTIF_NEW, (call: Call) => {
      this.triggerNotificationAnimation();
      this.hasCallNotifications = true;
    });
  }

  getOppositeLanguage(): string {
    const currentLang = localStorage.getItem('translationLanguage') || 'bg';

    return currentLang === 'bg' ? 'en' : 'bg';
  }

  swichLanguage(lang: string) {
    if (this.translate.currentLang !== lang) {
      localStorage.setItem('translationLanguage', lang);
      this.currentLanguage = lang;
      window.location.reload();
    }
  }

  toggleCurrency(): void {
    this.fxService.toggleCurrency();
  }

  handleToggleLeftSideNav(mode: DrawerMode, side: string) {
    this.toggleLeftSideNav(mode, side);
    this.resetNotifications();
  }

  toggleProductCalculator() {
    this.calculatorService.toggleCalculator();
  }

  backArrowClicked() {
    this.navigationMenuService.onCloseNavigationDrawerClick.next(true);
  }

  toggleLayout() {
    this.searchEvent.emit(this.collapsed);
  }

  triggerNotificationAnimation() {
    this.callNotificationAnimation = true;
    setTimeout(() => (this.callNotificationAnimation = false), 3000);
  }

  resetNotifications() {
    this.hasCallNotifications = false;
  }

  logout() {
    this.sessionService.logout();
  }
}
